import { WithdrawalRequest } from './types'

export const getAddress = (requestData: WithdrawalRequest, memoTokens: string[]) => {
  if (memoTokens.includes(requestData.currency) && requestData.beneficiary.metadata) {
    return `${requestData.beneficiary.value}:${requestData.beneficiary.metadata}`
  }
  return requestData.beneficiary.value
}

type Request = {
  address?: string
  amount: Number
  beneficiary?: string
  currency: string
  twoFactorCode?: string
}
const buildApiRequest = (requestData: WithdrawalRequest, memoTokens: string[] = []): Request => {
  const base: Request = {
    amount: requestData.amount,
    currency: requestData.currency
  }

  if (requestData.isFiat) {
    return {
      ...base,
      beneficiary: requestData.beneficiary.value,
      twoFactorCode: requestData.secondFactor
    }
  }

  // send to external crypto address
  // send to blockchain wallet
  if (requestData.beneficiary.type === 'external' || requestData.beneficiary.type === 'wallet') {
    return {
      ...base,
      address: getAddress(requestData, memoTokens),
      twoFactorCode: requestData.secondFactor
    }
  }

  // send to whitelisted address
  return {
    ...base,
    beneficiary: requestData.beneficiary.type
  }
}

export default buildApiRequest
